import http from "./http-common";
import { getAuthToken } from "./authService";

const BASE = "/api/v1/admin/bulk-email";

// Mirrors the @Size constraints on BulkEmailRequestDto / BulkEmailPreviewDto so the UI can
// stop the admin before the server rejects a long draft.
export const SUBJECT_MAX_LENGTH = 255;
export const BODY_MAX_LENGTH = 10000;

const authHeaders = async () => ({
  Authorization: `Bearer ${await getAuthToken()}`,
});

/**
 * Renders the draft through the backend's own layout so what the admin sees is the same
 * HTML the sender produces. Deliberately server-side: a local copy of the wrapper would
 * drift from email_templates/layout.html the first time either is edited.
 */
export const previewBulkEmail = async ({ subject, body, sampleRecipientName }) => {
  const response = await http.post(
    `${BASE}/preview`,
    { subject, body, sampleRecipientName },
    { headers: await authHeaders() }
  );
  return response.data;
};

/** Who a "send to all" reaches. ACTIVE_USERS = signed in to this dashboard at least once. */
export const AUDIENCE = {
  ACTIVE_USERS: "ACTIVE_USERS",
  LEGACY_ALL: "LEGACY_ALL",
};

/** How many people a "send to all" would actually reach for the given audience. */
export const fetchRecipientCount = async (audience = AUDIENCE.ACTIVE_USERS) => {
  const response = await http.get(`${BASE}/recipients`, {
    params: { audience },
    headers: await authHeaders(),
  });
  return response.data;
};

/** One address only — used for the test send before a fan-out. */
export const sendTestEmail = async ({ subject, body, emailAddress }) => {
  const response = await http.post(
    BASE,
    { subject, body, emailAddress, sendAll: false },
    { headers: await authHeaders() }
  );
  return response.data;
};

/** Fans out to the chosen audience. The backend returns as soon as the run is queued. */
export const sendBulkEmailToAll = async ({ subject, body, audience = AUDIENCE.ACTIVE_USERS }) => {
  const response = await http.post(
    BASE,
    { subject, body, sendAll: true, audience },
    { headers: await authHeaders() }
  );
  return response.data;
};

const BulkEmailService = {
  AUDIENCE,
  previewBulkEmail,
  fetchRecipientCount,
  sendTestEmail,
  sendBulkEmailToAll,
};

export default BulkEmailService;
